import React from 'react';
import { StarIcon } from 'lucide-react';
import { TESTIMONIALS } from '../utils/constants';
export function TestimonialsSection() {
  return <section className="bg-gray-50 py-16 px-4" data-id="element-282">
      <div className="max-w-7xl mx-auto" data-id="element-283">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-284">
          Cosa dicono gli insegnanti che lo usano
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-285">
          {TESTIMONIALS.map((testimonial, index) => <div key={index} className="bg-white rounded-lg shadow-lg p-6" data-id="element-286">
              <div className="flex gap-1 mb-4" data-id="element-287">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-288" />)}
              </div>
              <p className="text-gray-700 italic mb-4" data-id="element-289">
                "{testimonial.review}"
              </p>
              <div className="border-t border-gray-200 pt-4" data-id="element-290">
                <div className="font-bold text-gray-900" data-id="element-291">
                  {testimonial.name}
                </div>
                <div className="text-sm text-gray-600" data-id="element-292">
                  {testimonial.age} anni, {testimonial.city}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}